module.exports = __webpack_public_path__ + "img/filter.e317bcdb.svg";